export default "__VITE_ASSET__70cb647e__"